import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAnchorComponent } from "./med-icon-anchor.component";

@NgModule({
  declarations: [
    MedIconAnchorComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAnchorComponent,
  ],
})
export class MedIconAnchorModule { }
